import React from 'react';
export function ServiceWorkshops() {
  const topics = [{
    title: 'AI Transformation for Teams',
    description: 'how to move from chaotic individual experimentation to coordinated team capability.'
  }, {
    title: 'The Six Personas of Product Leadership',
    description: 'the skill sets most companies never teach their product leaders.'
  }, {
    title: 'Strategic Thinking for Leaders',
    description: 'how to make room for strategic work when your calendar is full of execution.'
  }];
  return <section className="w-full bg-brand-light-gray py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-346" data-mp="3e8sfefseemsj">
      <div className="max-w-7xl mx-auto" data-id="element-347" data-mp="3ean3u42vox1d">
        <div className="max-w-4xl mb-10" data-id="element-348" data-mp="39htv754ah4k0">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-8" data-id="element-349" data-mp="39fzbtv8o1ki1">
            Workshops & speaking
          </h2>
          <p className="text-xl md:text-2xl text-brand-gray leading-relaxed" data-id="element-350" data-mp="2gteod5vb9sjr">
            I also speak and lead workshops on AI transformation, product
            leadership, and strategic thinking. Interactive, framework-driven.
            Your audience walks away with tools they can use the next day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-351" data-mp="2jjjj4fgl2j9u">
          {topics.map((topic, index) => <div key={index} className="bg-white p-10 rounded-lg shadow-sm border-t-4 border-brand-orange flex flex-col" data-id="element-352" data-mp="2og9yf0kkdau7" data-mpi={index}>
              <h3 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-353" data-mp="1vse2hy2tjmyh">
                {topic.title}
              </h3>
              <p className="text-lg text-brand-gray leading-relaxed flex-grow" data-id="element-354" data-mp="20qxqe40z38th">
                {topic.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}